import React from 'react';
import ProjectVideo from '../../../../components/project/project-video';

const SteveMaddenCaseStudy = ({ acf }) => {
  return (
    <React.Fragment>
      <ProjectVideo
        videoId={acf.video_id}
        videoThumbnail={acf.video_thumbnail}
        blurb={acf.video_blurb}
        wrapperPadding={'0 0 10vw 0'}
      />
    </React.Fragment>
  );
};

export default SteveMaddenCaseStudy;



// WEBPACK FOOTER //
// ./src/templates/project/case-studies/steve-madden/index.js